import { Http } from '@/lib/http';
export class GeneralLoanWaiverService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/loan-waivers/';
  }
  createGeneralLoanWaiverSetting() {
    return this.httpClient().post(`${this.endpoint}`);
  }
  getGeneralLoanWaiverSettings() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  getGeneralLoanWaiverSetting(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }
  updateGeneralLoanWaiverSetting(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
  updateLevelActive(payload) {
    return this.httpClient().patch(
      `${this.endpoint}level-active/${payload.id}`,
      payload
    );
  }
}
